<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right" style="align-items: center;">
                <el-checkbox v-model="showEmpty" style="margin-right: 12px;" @change="afterInitialData">显示空行</el-checkbox>
                <el-date-picker v-model="dateFilter.start" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择起始日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-date-picker v-model="dateFilter.end" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择终止日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="filterRecords" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="adminName" label="管理员名称"></el-table-column>
            <el-table-column prop="addressName" label="库存地" width="110"></el-table-column>
            <el-table-column prop="categoryName" label="类目" width="120"></el-table-column>
            <el-table-column label="创建时间" width="160">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.adminDate) }}
                </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.adminStatus == 1 ? "启用" : "禁用" }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="customerName" label="出品人"> </el-table-column> -->
            <el-table-column label="图片代卖(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount2 + "枚 | " + scope.row.resalerTotal2 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="实物代卖(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount3 + "枚 | " + scope.row.resalerTotal3 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="锁定(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.logCount5 + "枚 | " + scope.row.logTotal5 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="出库(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.logCount6 + "枚 | " + scope.row.logTotal6 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="最后登录时间">
                <template slot-scope="scope">
                    {{ scope.row.adminDateLast ? convertToDate(scope.row.adminDateLast) : "-" }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small" v-if="scope.row.adminSuper == 0">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="120px">
                    <el-form-item label="管理员账号">
                        <el-input v-model="handleInfo.adminName"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员密码">
                        <el-input v-model="handleInfo.adminPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model="handleInfo.adminPhone"></el-input>
                    </el-form-item>
                    <el-form-item label="选择出品人">
                        <el-select v-model="handleInfo.customerId" placeholder="请选择" style="width: 100%;">
                            <el-option :label="'暂无'" :value="''"></el-option>
                            <el-option v-for="item in customers" :key="item.customerId" :label="item.customerName" :value="item.customerId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择朝代">
                        <el-select v-model="handleInfo.categoryId" placeholder="请选择" style="width: 100%;">
                            <el-option :label="'暂无'" :value="''"></el-option>
                            <el-option v-for="item in categoryies" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员状态">
                        <el-select v-model="handleInfo.adminStatus" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in statusArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员类型">
                        <el-select v-model="handleInfo.adminSuper" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择权限">
                        <el-select v-model="handleInfo.adminPermissions" multiple placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in permissions" :key="'permission' + item.permissionId" :label="item.permissionName" :value="item.permissionId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择库存地">
                        <el-select v-model="handleInfo.addressId" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in addresses" :key="'permission' + item.addressId" :label="item.addressName" :value="item.addressId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, enumMixin],
    data: function () {
        return {
            showEmpty: true,
            statusArray: [
                {
                    label: "启用",
                    value: 1
                },
                {
                    label: "禁用",
                    value: 0
                },
            ],
            typeArray: [
                {
                    label: "超级管理员",
                    value: 1
                },
                {
                    label: "普通管理员",
                    value: 0
                },
            ],
            customers: [],
            addresses: [],
            categoryies: [],
            binds: [],
            permissions: [],
            filterRecords: [],
            dateFilter: {
                start: "",
                end: ""
            }
        }
    },
    methods: {
        afterInitialData: function() {
            this.filterRecords = [];
            for (let i = 0; i < this.records.length; i++) {
                if (this.showEmpty || this.records[i].resalerCount2 > 0 || this.records[i].resalerCount3 > 0 || this.records[i].logCount5 > 0 || this.records[i].logCount6 > 0) {
                    this.filterRecords.push(this.records[i]);
                }
            }
        },
        dateChange: function(e) {
            console.log(e);
        },
        beforeHandleSubmit: function() {
            this.handleInfo.adminPermissions = this.handleInfo.adminPermissions.join(",");
        },
        beforeHandleOpen: function(handle) {
            if (handle == "insert") {
                this.handleInfo.adminStatus = 1;
                this.handleInfo.adminSuper = 0;
            }
            if (this.handleInfo.adminPermissions) { 
                if (this.handleInfo.adminPermissions) {
                    this.handleInfo.adminPermissions = this.handleInfo.adminPermissions.split(',');
                }
                else {
                    this.handleInfo.adminPermissions = [];
                }
            }
        },
        reloadData: async function() {
            this.customers = await doGet(API.ALL.CUSTOMER);
            this.categoryies = await doGet(API.ALL.CATEGORY);
            this.permissions = await doGet(API.ALL.PERMISSION);
            this.addresses = await doGet(API.ALL.ADDRESS);
            this.addresses.unshift({
                addressId: "",
                addressName: "暂无"
            });
        },
        initialParam: function() {
            this.filterParams.startDate = this.dateFilter.start.getTime() / 1000;
            this.filterParams.endDate = this.dateFilter.end.getTime() / 1000;
        }
    },
    created: async function () {
        let now = new Date();
        // this.dateFilter.start = new Date(now.getFullYear(), now.getMonth(), 1);
        this.dateFilter.start = new Date("2025-06-01");
        this.dateFilter.end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.size = 1000;
        this.tag = "ADMIN";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>